// extracted by mini-css-extract-plugin
module.exports = {"loginFormWrapper":"register_loginFormWrapper__3Nv-z","form":"register_form__19yd0"};